import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Initialize i18n
import './i18n';
import { logError } from './utils/logger';
import { installCsrfInterceptor } from './utils/csrf';

installCsrfInterceptor();

// Global error handlers — all errors route through structured logger (Commandment IX)
window.addEventListener('unhandledrejection', (event) => {
  logError(event.reason, { context: 'unhandledrejection' });
  event.preventDefault();
});

window.addEventListener('error', (event) => {
  logError(event.error ?? new Error(event.message), { context: 'window.onerror' });
});

// Loading fallback for i18n
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-stone-50">
    <div className="text-stone-500">Loading...</div>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <App />
    </Suspense>
  </React.StrictMode>,
);
